module.exports = __webpack_public_path__ + "img/base_divers_commerce.8e019390.svg";